import {AppLayout, BreadcrumbGroup} from '@amzn/awsui-components-react';
import React from "react";
import Navigation from "../Navigation/Navigation";
import PartnerForm from "./PartnerForm";

const Breadcrumbs = () => (
  <BreadcrumbGroup
    items={[
      {
        text: 'BEE Tool',
        href: '#/Dashboard'
      },
      {
        text: 'Add Partner'
      }
    ]}
  />
);

export default class SubmitFundingRequestPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {toolsOpen: false}
  }

  render() {
    return (
      <AppLayout
        navigation={<Navigation authState={this.props.authState} />}
        breadcrumbs={<Breadcrumbs />}
        content={<PartnerForm/>}
        contentType="form"
        toolsHide={true}
      />
    )
  }
}